import { render, staticRenderFns } from "./to-do-check.vue?vue&type=template&id=18388798&scoped=true"
import script from "./to-do-check.vue?vue&type=script&lang=js"
export * from "./to-do-check.vue?vue&type=script&lang=js"
import style0 from "./to-do-check.vue?vue&type=style&index=0&id=18388798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18388798",
  null
  
)

export default component.exports